import { Pie } from '../BaseCharts'
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  extends: Pie,
  data: function() {
    return {
      pendingCount: '',
      assignedCount: '',
      pickedupCount: ''
    }
  },
  created: function() {
    this.getPendingCount()
  },
  mounted () {
  },

  methods: {
    getPendingCount: function() {

       var userdata = localStorage.getItem('userData');
       var userInfo = JSON.parse(userdata);
       var usrObj = {
         pickuplocationpincode: `${userInfo.pickuplocationpincode}`
       };
       // console.log(usrObj);
       this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetDashboardChartData`, usrObj)
        .then((response) => {
          if (response) {
            var result = JSON.parse(response.bodyText);
            this.pendingCount = parseInt(result.returnvalue[0].reversepickup);
            //this.pendingCount = parseInt(result.returnvalue[0].pickuppending);
            if(isNaN(this.pendingCount)) {
            this.pendingCount = 0;
            }
           // this.assignedCount = parseInt(result.returnvalue[0].totalofd) + parseInt(result.returnvalue[0].pickuppending);
           this.assignedCount =parseInt(result.returnvalue[0].forwardpickup);
            if(isNaN(this.assignedCount)) {
            this.assignedCount = 0;
            }
            //this.pickedupCount = parseInt(result.returnvalue[0].totalofd);
            this.pickedupCount = parseInt(result.returnvalue[0].totalrto);
            if(isNaN(this.pickedupCount)) {
            this.pickedupCount = 0;
            }
           
            document.getElementById('pickuppending').innerHTML=(this.pendingCount)?this.pendingCount:'0';
            document.getElementById('pickupassigned').innerHTML=this.assignedCount;
            document.getElementById('totalrto').innerHTML=this.pickedupCount;

            // console.log(this.pendingCount);
            var total_lables = parseInt(this.pendingCount) + parseInt(this.assignedCount) + parseInt(this.pickedupCount)

            this.renderChart({
              labels: ['Forward Pickup', 'Reverse Pickup','Total RTO'],
              datasets: [
                {
                  backgroundColor: [
                   
                    '#00c0ef',
                     '#ffa500',
                    '#00a65a'
                  ],
                  data: [this.assignedCount,this.pendingCount, this.pickedupCount]

                }
              ]
            }, {
              responsive: true,
              maintainAspectRatio: false,
                 tooltips: {
                   callbacks: {
                     title: function(tooltipItem, data) {
                       return data['labels'][tooltipItem[0]['index']];
                     },
                     label: function(tooltipItem, data) {
                       return data['datasets'][0]['data'][tooltipItem['index']];
                     },
                     afterLabel: function(tooltipItem, data) {
                       var dataset = data['datasets'][0];
                       var percent = Math.round((dataset['data'][tooltipItem['index']] / total_lables) * 100)
                       return '(' + percent + '%)';
                     }
                   },
                   //backgroundColor: '#FFF',
                   titleFontSize: 16,
                   titleFontColor: '#FFFFFF',
                   bodyFontColor: '#FFFFFF',
                   bodyFontSize: 14,
                   displayColors: true
                 }
               })
          } else {
            alert('Data not found')
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
  }
}
